export default __webpack_public_path__ + "static/media/sun.d958b628.svg";